let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
  {
    label: "设备名称",
    props: "deviceName",
    minWidth: 200,
  },
  {
    label: "设备编号",
    props: "deviceCode",
    minWidth: 200,
  },
  {
    label: "共享开关型号",
    props: "typeName",
    minWidth: 200,
  },
  {
    label: "是否开通共享",
    props: "shareActiveName",
    minWidth: 200,
  },
  {
    label: "开通共享时间",
    props: "openShareActiveTime",
    minWidth: 200,
  },
  {
    label: "当前共享状态",
    props: "shareModeName",
    minWidth: 200,
  },
  // 23-06-02 添加
  {
    label: "共享开关实时状态",
    props: "shareLocalStatusName",
    minWidth: 200,
  },
  {
    label: "共享列表实时状态",
    props: "shareListLocalStatus",
    minWidth: 200,
  },
  {
    label: "绑定渠道",
    props: "bindChannelName",
    minWidth: 200,
  },
  {
    label: "支持协议",
    props: "connectProtocol",
    minWidth: 200,
  },
  {
    label: " 所属用户",
    props: "custMobile",
    minWidth: 200,
  },
  {
    label: "绑定时间",
    props: "bindTime",
    minWidth: 200,
  },
  {
    label: "最近订单开始时间",
    props: "lastOrderTime",
    minWidth: 200,
  },
  {
    label: "剩余补贴发放时间",
    props: "endDisbursementTime",
    minWidth: 200,
  },
];

// 列表展示项
pageConfig.reservationListColumns = [
  {
    label: "共享充电订单ID",
    props: "remark",
    minWidth: 200,
  },
  {
    label: "关联预约订单ID",
    props: "bindSource",
    minWidth: 300,
    tooltip: true,
  },
  {
    label: "共享设备类型",
    props: "custPhone",
    minWidth: 200,
  },
  {
    label: "充电设备编号/IMEI",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "站点名称",
    props: "onoff",
    minWidth: 200,
    formatter: function (row) {
      return "生效";
    },
  },
  {
    label: "充电业务归属",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "充电用户账号类型",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "共享充电类型",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "订单状态",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "订单属性",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "开始时间",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "结束时间",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "结束方式",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "充电时长",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "充电电量",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "充电预付费用（元）",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "充电实付费用（元）",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "已退预付费用（元）",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "已退实收费用（元）",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "预付退款状态",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "预付退款完成时间",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "备注",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "更新人",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "更新时间",
    props: "updateDate",
    minWidth: 200,
  },
];
pageConfig.sharedListColumns = [
  {
    label: "共享预约订单ID",
    props: "remark",
    minWidth: 200,
  },
  {
    label: "关联充电订单ID",
    props: "bindSource",
    minWidth: 300,
    tooltip: true,
  },
  {
    label: "共享预约类型",
    props: "custPhone",
    minWidth: 200,
  },
  {
    label: "预约设备编号/IMEI",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "设备所属用户手机号",
    props: "onoff",
    minWidth: 200,
    formatter: function (row) {
      return "生效";
    },
  },
  {
    label: "充电用户账号类型",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "下单用户手机号",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "站点名称",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "站点地址",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "预约业务归属",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "共享设备类型",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "订单状态",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "当前预约开始时间",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "当前预约结束时间",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "下单时间",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "修改次数",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "原始预约开始时间",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "原始预约结束时间",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "备注",
    props: "updateDate",
    minWidth: 200,
  },
  {
    label: "更新时间",
    props: "updateDate",
    minWidth: 200,
  }
];
// 列表展示项
pageConfig.custDetailColumns = [
  {
    label: "操作时间",
    props: "lastModifiedWhen",
    minWidth: 200,
  },
  {
    label: "充值金额（元）",
    props: "inExpAmount",
    minWidth: 200,
    tooltip: true,
    formatter: function formatter(row, column, cellValue, index) {
      // 做判断
      if (row.operateType == "01") {
        return row.inExpAmount;
      } else {
        return "";
      }
    },
  },
  {
    label: "退款金额（元）",
    props: "inExpAmount",
    minWidth: 200,
    formatter: function formatter(row, column, cellValue, index) {
      // 做判断
      if (row.operateType == "07") {
        return row.inExpAmount;
      } else {
        return "";
      }
    },
  },
  {
    label: "账户剩余金额（元）",
    props: "changeFreeBal",
    minWidth: 200,
  },
  {
    label: "操作人",
    props: "lastModifiedByName",
    minWidth: 200,
  },
  {
    label: "备注",
    props: "remark",
    minWidth: 200,
  },
];

// 故障信息
pageConfig.faultDetailColumns = [
  {
    label: "通知类型",
    props: "statusTypeName",
    minWidth: 200,
    formatter: function (row) {
      return "故障";
    },
  },
  {
    label: "故障状态",
    props: "pileStatusName",
    minWidth: 200,
  },
  {
    label: "备注",
    props: "remark",
    minWidth: 200,
  },
  {
    label: "时间",
    props: "createdWhen",
    minWidth: 200,
  },
];

// 报文日志列表
pageConfig.logListColumns = [
  {
    label: "充电桩IMEI码",
    props: "rcsCode",
    minWidth: 200,
  },
  {
    label: "方向",
    props: "messageTypeName",
    minWidth: 200,
  },
  {
    label: "第一条消息类型名称",
    props: "firstMessageTypeName",
    minWidth: 200,
  },
  {
    label: "第二条消息类型名称",
    props: "secondMessageTypeName",
    minWidth: 200,
  },
  {
    label: "时间",
    props: "createdWhen",
    minWidth: 200,
  },
];
// 报文日志列表
pageConfig.updateListColumns = [
  {
    label: "充电桩IMEI码",
    props: "pileNo",
    minWidth: 200,
  },
  {
    label: "升级任务名称",
    props: "versionDesc",
    minWidth: 200,
  },
  {
    label: "升级版本名称",
    props: "versionDesc",
    minWidth: 200,
  },
  {
    label: "升级版本号",
    props: "currentVersionNo",
    minWidth: 200,
  },
  {
    label: "升级前版本号",
    props: "versionId",
    minWidth: 200,
  },
  {
    label: "升级状态",
    props: "upgradeStatus",
    minWidth: 200,
  },
  {
    label: "版本更新内容",
    props: "versionDesc",
    minWidth: 200,
  },
  {
    label: "计划升级时间",
    props: "upgradeStartTime",
    minWidth: 200,
  },
  {
    label: "升级完成时间",
    props: "upgradeEndTime",
    minWidth: 200,
  },
];

// // 面包屑
pageConfig.listBreadCrumb = [
  {
    type: "title",
    name: "首页",
  },
  {
    type: "title",
    name: "充电桩设备列表",
  },
];

// 列表-表格属性
pageConfig.tableConfig = {
  showSelection: true,
  showIndex: false,
};
// 列表-表格属性
pageConfig.noSeltableConfig = {
  showSelection: false,
  showIndex: false,
};

// dialog列表-表格属性
pageConfig.dialogTableConfig = {
  showSelection: false,
  showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50, 100],
};

// 列表-分页参数
pageConfig.detailPagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50, 100],
};
// 车辆信息 - 分页参数
pageConfig.carPagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50, 100],
};
// 列表-编辑操作
pageConfig.tableEditObj = {
  editKey: "id",
  editRouter: "pileModelDetail",
};

// 路由
pageConfig.listRouter = "pileList";

// 详情的面包屑
pageConfig.detailBreadCrumb = [
  {
    type: "title",
    name: "首页",
  },
  {
    type: "router",
    name: " 充电桩设备列表",
    router: "pileList",
  },
  {
    type: "title",
    name: "详情",
  },
];

pageConfig.formRules = {
  pileTypeName: [
    {
      required: true,
      message: "请填写充电桩型号名称",
      trigger: "blur",
    },
  ],
};

pageConfig.labelFormRules = {
  configName: [
    {
      required: true,
      message: "请填写标签名称",
      trigger: "blur",
    },
  ],
  configVal: [
    {
      required: true,
      message: "请填写编号",
      trigger: "blur",
    },
  ],
};

pageConfig.dealerFormRules = {
  dealerNo: [
    {
      required: true,
      message: "请填写运营商全称",
      trigger: "blur",
    },
  ],
  mobile: [
    {
      required: true,
      message: "请填写客户手机号",
      trigger: "blur",
    },
    {
      pattern:
        /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/,
      message: "手机号填写错误",
      trigger: "blur",
    },
  ],
};

pageConfig.selectFormRules = {
  remark: [
    {
      required: true,
      message: "请填写备注",
      trigger: "blur",
    },
  ],
  chargeValue: [
    {
      required: true,
      message: "请输入充值度电",
      trigger: "blur",
    },
  ],
};

pageConfig.remarkFormRules = {
  remark: [
    {
      required: true,
      message: "请填写备注",
      trigger: "blur",
    },
  ],
};

// ========== 共享用户列表（私桩共享信息详情页 - Tab 6 底部） ==========

// 共享用户类型字典
pageConfig.relationTypeMap = {
  SHARED: '共享',
  BLACKLIST: '黑名单',
  WHITELIST: '白名单',
};

// 共享用户添加方式字典
pageConfig.sourceMap = {
  FAVORITE: '收藏电站',
  CHARGE: '扫码充电',
  RESERVE: '预约充电',
  MANUAL: '手动添加',
  MIGRATION: '数据迁移',
};

// 是否愿意交换车位字典（hasParkSpace: Y/N/空）
pageConfig.hasParkSpaceMap = {
  Y: '是',
  N: '否',
};

// 是否收藏字典（favorite: Y/N）
pageConfig.favoriteMap = {
  Y: '是',
  N: '否',
};

// 用户列表列定义（绑定 custMobile/relationTypeName 等已格式化字段）
pageConfig.shareUserListColumns = [
  { label: '共享用户账号',       props: 'custMobile',          minWidth: 120 },
  { label: '共享用户类型',       props: 'relationTypeName',     minWidth: 100 },
  { label: '共享用户添加方式',   props: 'sourceName',           minWidth: 120 },
  { label: '是否愿意交换车位',   props: 'hasParkSpaceName',     minWidth: 120 },
  { label: '车位信息',           props: 'parkSpace',            minWidth: 100 },
  { label: '使用充电次数',       props: 'usageCount',           minWidth: 100 },
  { label: '是否收藏',           props: 'favoriteName',         minWidth: 80 },
  { label: '创建时间',           props: 'createdWhen',          minWidth: 150 },
  { label: '最新更新时间',       props: 'lastModifiedWhen',     minWidth: 150 },
];

// 变更记录列定义（弹窗内表格）
pageConfig.shareUserRelationLogColumns = [
  { label: '共享用户账号',       props: 'custMobile',              minWidth: 120 },
  { label: '变更前共享用户类型', props: 'beforeRelationTypeName',  minWidth: 140 },
  { label: '变更后共享用户类型', props: 'afterRelationTypeName',   minWidth: 140 },
  { label: '更新时间',           props: 'lastModifiedWhen',        minWidth: 150 },
];

// 用户列表 - 表格属性（不显示多选、显示序号）
pageConfig.shareUserListTableConfig = {
  showSelection: false,
  showIndex: true,
};

// 用户列表 - 分页参数
pageConfig.shareUserListPagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50, 100],
};

// 变更记录 - 表格属性（显示序号、不显示多选）
pageConfig.shareUserRelationLogTableConfig = {
  showSelection: false,
  showIndex: true,
};

// 变更记录 - 分页参数
pageConfig.shareUserRelationLogPagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50],
};

export default pageConfig;
